import { FolderOpenOutlined } from '@mui/icons-material';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import type { Dispatch, SetStateAction } from 'react';
import { useRef, useState } from 'react';

import type { FileManagerUploadingState } from '@/modules/files/components/file-manager/FileManagerUploadingBar';

import { useZipUploader } from '@/modules/files/hooks/useZipUploader';

import type { Segment } from '../FileManagerBreadcrumbsBarSegment';

import { UploadZipDialog } from './upload-zip-menu-item/UploadZipDialog';

interface Props {
  segment: Segment;
  setUploadingState: Dispatch<SetStateAction<FileManagerUploadingState>>;
  onClose: () => void;
  rootOwnerId: string;
}

export const UploadZipMenuItem = ({
  segment,
  setUploadingState,
  onClose,
  rootOwnerId,
}: Props) => {
  const [uploadZipDialogOpen, setUploadZipDialogOpen] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const { handleUploadRequest } = useZipUploader({
    segment,
    setUploadingState,
    rootOwnerId,
  });

  return (
    <>
      <MenuItem
        onClick={() => {
          onClose();
          setUploadZipDialogOpen(true);
        }}
      >
        <ListItemIcon>
          <FolderOpenOutlined />
        </ListItemIcon>
        <ListItemText>Upload a folder</ListItemText>
      </MenuItem>
      <UploadZipDialog
        open={uploadZipDialogOpen}
        onClose={() => {
          setUploadZipDialogOpen(false);
        }}
        onRequestUpload={() => {
          inputRef.current?.click();
        }}
      />
      <input
        ref={inputRef}
        type="file"
        style={{ display: 'none' }}
        autoComplete="off"
        onChange={async (event) => {
          setUploadZipDialogOpen(false);

          await handleUploadRequest(event);

          if (inputRef?.current?.value) {
            inputRef.current.value = '';
          }
        }}
        accept="application/zip"
      />
    </>
  );
};
